import { supabase } from './supabase'

/**
 * Get IP whitelist for organization
 */
export const getIPWhitelist = async (organizationId) => {
  try {
    const { data, error } = await supabase
      .from('ip_whitelist')
      .select('*')
      .eq('organization_id', organizationId)
      .order('created_at', { ascending: false })

    if (error) throw error
    return data || []
  } catch (error) {
    console.error('Error fetching IP whitelist:', error)
    throw error
  }
}

/**
 * Add IP to whitelist
 */
export const addIPToWhitelist = async (organizationId, ipAddress, description = null) => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    
    const { data, error } = await supabase
      .from('ip_whitelist')
      .insert({
        organization_id: organizationId,
        ip_address: ipAddress,
        description,
        created_by: user?.id,
      })
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error adding IP to whitelist:', error)
    throw error
  }
}

/**
 * Remove IP from whitelist
 */
export const removeIPFromWhitelist = async (organizationId, ipId) => {
  try {
    const { error } = await supabase
      .from('ip_whitelist')
      .delete()
      .eq('id', ipId)
      .eq('organization_id', organizationId)

    if (error) throw error
    return { success: true }
  } catch (error) {
    console.error('Error removing IP from whitelist:', error)
    throw error
  }
}

/**
 * Toggle IP whitelist status
 */
export const toggleIPWhitelistStatus = async (organizationId, ipId, isActive) => {
  try {
    const { error } = await supabase
      .from('ip_whitelist')
      .update({
        is_active: isActive,
        updated_at: new Date().toISOString(),
      })
      .eq('id', ipId)
      .eq('organization_id', organizationId)

    if (error) throw error
    return { success: true }
  } catch (error) {
    console.error('Error toggling IP whitelist status:', error)
    throw error
  }
}

/**
 * Check if current IP is whitelisted
 */
export const checkIPWhitelist = async (organizationId) => {
  try {
    // This would typically be done server-side
    // For client-side, we can check if IP whitelisting is enabled
    const { data, error } = await supabase
      .from('ip_whitelist')
      .select('*')
      .eq('organization_id', organizationId)
      .eq('is_active', true)

    if (error) throw error
    
    // If no whitelist entries, IP whitelisting is not enforced
    if (!data || data.length === 0) {
      return { whitelisted: true, enforced: false }
    }

    // Actual IP checking would be done server-side
    return { whitelisted: true, enforced: true }
  } catch (error) {
    console.error('Error checking IP whitelist:', error)
    return { whitelisted: true, enforced: false }
  }
}

